import type { ShiftStack } from '@/domain/templates/preview-stacks';

import { PreviewDayGrid } from './preview-grid';
import { ShiftStackCard } from './shift-stack-card';

interface StackedGridProps {
  /** Seven Mon–Sun columns of stacks, as built by `buildShiftStacks`. */
  columns: ShiftStack[][];
}

/**
 * The stacked preview: one {@link ShiftStackCard} "deck" per shift type + time
 * per day. The per-day header count is the total heads (sum of the decks' `×N`).
 */
export function StackedGrid({ columns }: StackedGridProps) {
  return (
    <PreviewDayGrid
      counts={columns.map((stacks) => stacks.reduce((total, stack) => total + stack.count, 0))}
      renderColumn={(index) =>
        columns[index].map((stack) => (
          <ShiftStackCard
            key={stack.key}
            typeName={stack.typeName}
            time={stack.time}
            count={stack.count}
            draft={stack.draft}
          />
        ))
      }
    />
  );
}
